import type { FaireProductEntity } from "../../entity_types/product";

export const p_q5h4s4hckd: FaireProductEntity = {
  token: "p_q5h4s4hckd",
  type: "product",
  name: "Rectangular 18K Golden SS Zodiac Signs Charm Necklace - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/983212c2acd033a18e79cbf73594cb7f5aca871eae6f6101f8e9061a24270cca.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6c1e0fbc73e7c40dcef60b4460d9deccc66ce5b61294d73d041be5273dc01f7e.jpeg",
    "https://cdn.faire.com/fastly/c4b24ce28c3392b0e8880b237c1453991f374fc7d8412925d836bb8ac759d2ea.jpeg",
    "https://cdn.faire.com/fastly/ef0cf045647c4cd13bd5dab4a22744d7c4a3de208e78dff8cda23a00e07df878.jpeg",
    "https://cdn.faire.com/fastly/f4dfd5ca2c642fa3e5726e2fdb06229ce6d0084376b95226994cc1c08eb353f9.jpeg",
    "https://cdn.faire.com/fastly/fc21f6ca73e2e754f3c5c60de8ba55d883f562c4c0a99f47be91d5ca4308867b.jpeg",
    "https://cdn.faire.com/fastly/ba59317392bc16481902c2376bf21160c3ee33eb408bad46064573412dae9ab8.jpeg",
    "https://cdn.faire.com/fastly/e3be2eb48760a2fed9b209d6e69fe491ed54ef68ab073784877010c9e8bfff6e.jpeg",
    "https://cdn.faire.com/fastly/f330e49bcecb976dca72f17b9808c8b7999d40162cd279aeae6884b45b0628dc.jpeg",
    "https://cdn.faire.com/fastly/62d4168e042c7afc59661a5e9eb71a695a93e146f27f1146adc3d6762bfc89c7.jpeg",
    "https://cdn.faire.com/fastly/20e3d16f80d8cd06b4814b79f751e98dc4358e4b1c81b3a2125afd14465ad643.jpeg",
    "https://cdn.faire.com/fastly/56f5e62c59a79dd37b8966b7992c3971abdcc66564b7210e5cb6b1d0638972b6.jpeg",
    "https://cdn.faire.com/fastly/9791fdf790a72f120dcf061596765c5503844452fba69099798ab436139f688c.jpeg",
    "https://cdn.faire.com/fastly/606c225dd0a69fb7a8b519f5355ca1c34e86f9e84f43baed8aeedf755f150b88.jpeg",
    "https://cdn.faire.com/fastly/d10c5084c72739f45ddad140fd55e305bb2b47ef01204697d5991fef196ffcc8.jpeg",
  ],
  priceDollars: 7.11,
  description:
    "Type: pendant necklace\n\nMaterial: 316L Stainless steel ，Cubic zirconia， 18K gold plated\n\nSize of pendant ： 11mm * 46mm\n\nLength of chain ： 440mm + 50mm\n\nProcess: Vacuum electroplating and manual polishing,Non tarnish\n\nSurface : High Polish\n\n★Made of high quality stainless steel，Lead-free，Harmless to Human Body.\n\n★Perfect jewelry gifts",
  tags: [],
  msrpDollars: 20.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:39.196Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
